// extracted by mini-css-extract-plugin
export default {"container":"MainNavigator_container__4P5ti","contentContainer":"MainNavigator_contentContainer__6A4CC"};